import * as o from "react";
import r from "../lib/IconBase.es.js";
import a from "../defs/ListPlus.es.js";
const s = o.forwardRef((t, e) => /* @__PURE__ */ o.createElement(r, { ref: e, ...t, weights: a }));
s.displayName = "ListPlusIcon";
const c = s;
export {
  c as ListPlus,
  s as ListPlusIcon
};
